import { render } from "./SelectItemRegion.vue?vue&type=template&id=6e3b7931&scoped=true"
import script from "./SelectItemRegion.vue?vue&type=script&lang=js"
export * from "./SelectItemRegion.vue?vue&type=script&lang=js"

import "./SelectItemRegion.vue?vue&type=style&index=0&id=6e3b7931&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3b7931"]])

export default __exports__